import appStore from 'store';
import api from './api';
import { PAGINATION} from './constants';

const store = {
  namespaced: true,
  state: {
    totalCount: 0,
    pagination: PAGINATION,
    userinfoDetail: {},
    userinfoDetailDialogVisible: false,
    dialogVisible: false,
    countryCodeList: [],
    blockInfoList:[],
  },
  getters: {
  
  },
  mutations: {
    setList(state, payload) {
      state.blockInfoList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setUserinfoDetailDialogVisible(state,payload){
      state.userinfoDetailDialogVisible=payload
    },
    setUserinfoDetail(state,payload){
      state.userinfoDetail=payload
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getBlockInfoList({commit},data){
      api.getBlockInfoList(data).then(res=>{
        commit('setList',res.data)
      })
    },
    delOne({commit},id){
    return  api.delOne(id).then(res=>{
        return res
      })
    },
    updatInfo({commit},blockInfoDto){
      return api.updatInfo(blockInfoDto).then(res=>{
        return res
      })
    }
  }
};

appStore.registerModule('blockInfo', store);
